export default __webpack_public_path__ + "static/media/ScaleHunter(3).c6d5e027.svg";